import React from "react";
import { useParams } from "react-router-dom";

import "./previewblog.css";

import PreviewBlogPage from "../../../common/PreviewBlog.jsx";

const PreviewBlog = () => {
  const { name } = useParams();
  const parts = name.split("-");
  const id = parts.pop();

  return (
    <>
      <PreviewBlogPage blogId={id} userType="admin" />
    </>
  );
};

export default PreviewBlog;
